import { ValidationResult, ValidatorResult } from '../index';
import { AnnotationShape } from '../../web-components/import-wizard/typings/pintura';
import { useStore as useProductStore } from '../../stores/product';
import { PmsColor } from '@midocean/webapps-shared-domain';

export const maxNumberOfColoursValidator =
  (shapes: AnnotationShape[], maximumColors: number, printPositionId: string) =>
  ({ payload, validationResult }: ValidatorResult): ValidatorResult => {
    const productStore = useProductStore();
    const validatorName = 'maxNumberOfColoursValidator';
    // in case of laser technique just return green result,
    // because we always convert it to one color
    // in case of full color, number of colours doesn't matter
    if (
      productStore.isLaserConverter(printPositionId) ||
      productStore.isDebossingTechnique(printPositionId) ||
      productStore.isFullColor(printPositionId)
    ) {
      return {
        payload,
        validationResult: validationResult.concat([
          {
            printPositionId: printPositionId,
            validatorName: validatorName,
            validatorColor: 'Green',
          },
        ]) as ValidationResult,
      };
    }

    const coloursToValidate = [];

    for (const shape of shapes) {
      if (shape.kind === 'Logo' && shape.pmsColorsInPngFile) {
        const { pmsColorsInPngFile } = shape;
        coloursToValidate.push(...pmsColorsInPngFile);
      } else if (shape.kind === 'Text') {
        coloursToValidate.push({
          name: shape.w2pText.colorName,
          red: shape.w2pText.color[0],
          green: shape.w2pText.color[1],
          blue: shape.w2pText.color[2],
        } as PmsColor);
      }
    }

    const coloursWithoutDuplicates = [
      ...new Set(coloursToValidate.map((item) => item.name)),
    ];

    if (coloursWithoutDuplicates.length > maximumColors) {
      return {
        payload,
        validationResult: validationResult.concat([
          {
            printPositionId: printPositionId,
            validatorName: validatorName,
            validatorColor: 'Red',
          },
        ]) as ValidationResult,
      };
    }

    return {
      payload,
      validationResult: validationResult.concat([
        {
          printPositionId: printPositionId,
          validatorName: validatorName,
          validatorColor: 'Green',
        },
      ]) as ValidationResult,
    };
  };
